import { deliveryTimesListField } from './fields/deliveryTimesList.field';

export const intervalsPolicies = {
    deliveryTimesList: deliveryTimesListField,
};
